import { ref } from 'vue'
import { useToast } from '@/composables/useToast'
import { useProjectStore } from '@/stores/project'

export interface ReportBugProjectOption {
  id: string
  name: string
}

/**
 * Same flow as Dashboard "Report Bug": no projects → toast; one project → open
 * create modal; multiple projects → open {@link ReportBugModal}, then create modal.
 */
export function useReportBugFlow() {
  const toast = useToast()
  const projectStore = useProjectStore()
  const showProjectSelector = ref(false)
  const modalProjects = ref<ReportBugProjectOption[]>([])
  const showCreateBugModal = ref(false)
  const selectedProjectId = ref('')

  function openReportBug() {
    const list: ReportBugProjectOption[] = (projectStore.projects || [])
      .filter((p: { is_deleted?: boolean }) => p?.is_deleted !== true)
      .map((p: { id: string; name?: string; title?: string }) => ({
        id: p.id,
        name: p.name || p.title || 'Untitled',
      }))
      .filter((p) => Boolean(p.id))

    if (list.length === 0) {
      toast.error('No projects available. Please create a project first.')
      return
    }

    if (list.length === 1) {
      selectedProjectId.value = list[0].id
      showCreateBugModal.value = true
      return
    }

    modalProjects.value = list
    showProjectSelector.value = true
  }

  function onProjectSelectedForBug(project: ReportBugProjectOption) {
    showProjectSelector.value = false
    selectedProjectId.value = project.id
    showCreateBugModal.value = true
  }

  function cancelProjectSelector() {
    showProjectSelector.value = false
  }

  return {
    showProjectSelector,
    modalProjects,
    showCreateBugModal,
    selectedProjectId,
    openReportBug,
    onProjectSelectedForBug,
    cancelProjectSelector,
  }
}
